import { Network } from '@/core/models/network.model'
import { Avatar, IconButton, List, ListItem, ListItemAvatar, ListItemText, Stack } from '@mui/material'
import { FC } from 'react'
import PublicIcon from '@mui/icons-material/Public'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import defaultNetworkCover from '@/assets/img/network-cover.png'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type NetworkResumeProps = {
  network: Network
  oversize?: boolean
}

export const NetworkResume: FC<NetworkResumeProps> = (props) => {
  const { network, oversize = false } = props
  const { t } = useTranslation()
  const navigate = useNavigate()
  const size = oversize ? 70 : 48
  const titleSize = oversize ? '20px' : '16px'
  const picSize = oversize ? '16px' : '14px'
  const fontSize = oversize ? '14px' : '12px'

  return (
    <List data-testid="network-resume" sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <ListItem>
        <ListItemAvatar sx={{ minWidth: 60, pr: 1 }}>
          <Avatar
            alt="cover-photo"
            src={network.coverPhoto?.url ?? defaultNetworkCover}
            variant="rounded"
            sx={{
              width: size,
              height: size,
              border: '1px solid rgba(0,0,0,0.4)',
              borderRadius: '6px',
            }}
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <strong style={{ fontSize: titleSize }}>{network.name}</strong>
            </Stack>
          }
          secondary={
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {network.privacy === 'public' && <PublicIcon sx={{ color: (theme) => theme.palette.grey[500], fontSize: picSize }} />}
              {network.privacy === 'private' && <LockOpenIcon sx={{ color: (theme) => theme.palette.grey[500], fontSize: picSize }} />}
              <Stack direction="row" spacing={0.5} sx={{ color: (theme) => theme.palette.grey[600], fontSize: { fontSize }, fontWeight: 400 }}>
                <span>{t(`page.network.privacy.${network.privacy}.primary`)}</span>
                <span>·</span>
                <span>{t('page.network.memberCount', { count: network.members.length })}</span>
              </Stack>
            </Stack>
          }
          secondaryTypographyProps={{
            component: 'div',
          }}
        />
      </ListItem>
    </List>
  )
}
